import { ScheduleItem } from "../ScheduleItem";
import { Schedule } from "../ValidationRangeCep/interface";
import { ScheduleContainer } from "./styles";

interface ScheduleListProps {
  schedulesList: Schedule[];
}

export const ScheduleList = ({ schedulesList }: ScheduleListProps) => {
  return (
    <>
      {schedulesList.map((schedule, index) => (
        <ScheduleContainer className="schedule-list" key={schedule.id}>
          <p className="group-name text-purple">
            Grupo de Produtos: {schedule.name}
          </p>

          <ScheduleItem scheduleItem={schedule.calendars} index={index + 1} />
        </ScheduleContainer>
      ))}
    </>
  );
};
